module.exports = __webpack_public_path__ + "img/内容图片.446af949.png";